const size = {
  mobileS: "321px",
  mobileM: "376px",
  mobileL: "426px",
  tablet: "769px",
  laptop: "1025px",
  laptopL: "1441px",
  desktop: "2561px",
};

export const DEVICES = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`,
};
